import { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { GlobalContext } from "../Context";
import moment from "moment";
import LoadingWheel from "../LoadingWheel";
import { blue, boxShadow, green, white } from "../../../theme/colours";
import { GiftIcon } from "../Icons";

const CampaignCardsV2 = ({
  title,
  type,
  neededScore,
  startDate,
  endDate,
  prizeDesc,
  entries,
  banner,
}) => {
  const { largeView, tabletView, mobileView, desktopView, optionState } =
    useContext(GlobalContext);

  const [formattedEntries, setFormattedEntries] = useState();
  const [entryLoading, setEntryLoading] = useState(true);

  const challengeCardStyle = {
    display: "flex",
    backgroundColor: white,
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: `0px 10px 15px ${boxShadow}`,
    height: desktopView ? "45.5%" : tabletView ? "48%" : "100%",
    width: tabletView || mobileView ? "100%" : "calc(50% - 0.25rem)",
    mt: desktopView && "1.5%",
    ...(mobileView && {
      minHeight: "8rem",
    }),
  };
  const textAreaStyle = {
    flex: 1,
    p: "3%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  };
  const titlePrizeAreaStyle = {
    display: "flex",
    justifyContent: "space-between",
  };
  const titleStyle = {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: desktopView ? 3 : tabletView && 2,
    overflow: "hidden",
    ...(mobileView && {
      fontSize: "0.875rem",
    }),
  };
  const ticketBoxStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: blue[1],
    borderRadius: "10px",
    minWidth: largeView ? "2.75rem" : "2.5rem",
    height: largeView ? "1.35rem" : "1.25rem",
    p: "0 0.25rem",
  };
  const entriesTextStyle = {
    fontWeight: 500,
    color: white,
    fontSize: "0.75rem",
    lineHeight: 1,
    ml: "0.25rem",
  };
  const smallMobileText = {
    ...(mobileView && {
      fontSize: "0.75rem",
    }),
  };
  const enterStyle = {
    fontWeight: 700,
    mr: "0.25rem",
    ...smallMobileText,
  };
  const enterDescStyle = {
    fontWeight: 300,
    ...smallMobileText,
  };
  const descBoxStyle = {
    display: "flex",
    justifyContent: "flex-start",
  };
  const giftBoxStyle = {
    display: "flex",
    alignItems: "center",
  };
  const botDescBoxStyle = {
    display: "flex",
    flexWrap: "wrap",
  };
  const giftIconStyle = { fill: green[2], width: "15px" };
  const giftCardTextStyle = {
    fontWeight: 600,
    color: green[2],
    ml: "0.25rem",
  };
  const bannerStyle = {
    width: "30%",
    height: "100%",
  };
  const dateStyle = {
    opacity: 0.4,
    fontStyle: "italic",
    smallMobileText,
  };
  const runsFromStyle = {
    ...dateStyle,
    fontWeight: 500,
    mr: "0.25rem",
    smallMobileText,
  };

  useEffect(() => {
    let formattedEntries = 0;

    if (entries) {
      formattedEntries = entries;

      if (entries >= 1000) {
        const temp = Math.floor(Math.log10(entries));

        formattedEntries =
          temp === 3
            ? `${Math.round((entries / 1000) * 10) / 10}k`
            : `${Math.round(entries / 1000)}k`;
      }
    }
    setFormattedEntries(formattedEntries);
    setEntryLoading(false);
  }, [optionState]);

  const differentYears = (date) => {
    if (moment(startDate).year() !== moment(endDate).year()) {
      return `, ${moment(date).format("YYYY")}`;
    }

    return "";
  };

  return (
    <Box sx={challengeCardStyle}>
      <Box component="img" src={banner} alt="Banner" sx={bannerStyle} />
      <Box sx={textAreaStyle}>
        <Box sx={titlePrizeAreaStyle}>
          <Typography variant="h3" sx={titleStyle}>
            {title}
          </Typography>
          {!entryLoading ? (
            <Box sx={ticketBoxStyle}>
              <img
                src="images/ticket.svg"
                alt="ticket icon"
                width={largeView ? "15px" : "13px"}
                height="inherit"
              />
              <Typography sx={entriesTextStyle}>{formattedEntries}</Typography>
            </Box>
          ) : (
            <LoadingWheel width={3} />
          )}
        </Box>
        <Box sx={giftBoxStyle}>
          <GiftIcon style={giftIconStyle} />
          <Typography sx={giftCardTextStyle}>{prizeDesc}</Typography>
        </Box>
        <Box sx={descBoxStyle}>
          <Typography sx={enterStyle}>{"ENTER:"}</Typography>
          <Typography sx={enterDescStyle}>
            {`Get a ${type.toLowerCase()} score of ${neededScore}+.`}
          </Typography>
        </Box>
        <Box sx={botDescBoxStyle}>
          <Typography sx={runsFromStyle}>{"Runs from:"}</Typography>
          <Typography sx={dateStyle}>
            {`${
              moment(startDate).format("MMM D") + differentYears(startDate)
            } - ${moment(endDate).format("MMM D") + differentYears(endDate)}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CampaignCardsV2;
